import { IVisaPrepForm, IPhone } from '../../../../../../types';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasArrivalDate'
  | 'arrivalDate'
  | 'familyContactAddress'
  | 'familyContactCity'
  | 'familyContactCountry'
  | 'familyContactPostcode'
  | 'familyMembers'
  | 'hasOtherContactAddress'
  | 'lengthOfStayDays'
  | 'lengthOfStayMonths'
  | 'lengthOfStayYears'
  | 'otherContactAddress'
  | 'otherContactCity'
  | 'otherContactCountry'
  | 'otherContactPostcode'
  | 'stayingWithFamily'
  | 'ukFamily'
  | 'ukPresence'
> & {
  familyPhoneNumber?: IPhone;
  otherPhoneNumber?: IPhone;
};

type Params = Fields & {
  arrivalDateError: string;
  familyEmailInputError: string;
  isFamilyPhoneValid: boolean;
  isOtherPhoneValid: boolean;
};

export function getPageStatus({
  hasArrivalDate,
  arrivalDateError,
  familyEmailInputError,
  isFamilyPhoneValid,
  isOtherPhoneValid,
  arrivalDate,
  familyContactAddress,
  familyContactCity,
  familyContactCountry,
  familyContactPostcode,
  familyPhoneNumber,
  familyMembers,
  hasOtherContactAddress,
  lengthOfStayDays,
  lengthOfStayMonths,
  lengthOfStayYears,
  otherContactAddress,
  otherContactCity,
  otherContactCountry,
  otherContactPostcode,
  otherPhoneNumber,
  stayingWithFamily,
  ukFamily,
  ukPresence
}: Params): { complete: boolean } {
  let complete = true;
  
  if (
    hasArrivalDate === undefined ||
    (hasArrivalDate === true &&
      (arrivalDateError !== '' ||
        arrivalDate === undefined ||
        arrivalDate === '' ||
        lengthOfStayDays === undefined ||
        lengthOfStayMonths === undefined ||
        lengthOfStayYears === undefined ||
        (lengthOfStayDays === 0 && lengthOfStayMonths === 0 && lengthOfStayYears === 0))) ||
    ukPresence === undefined ||
    ukFamily === undefined ||
    (ukFamily === true &&
      (stayingWithFamily === undefined ||
        (stayingWithFamily === true &&
          (familyContactAddress === undefined ||
            familyContactAddress === '' ||
            familyContactCity === undefined ||
            familyContactCity === '' ||
            familyContactCountry === undefined ||
            familyContactCountry === '' ||
            familyPhoneNumber === undefined ||
            familyEmailInputError !== '' ||
            (familyPhoneNumber && (familyPhoneNumber.code === null || familyPhoneNumber.phone === null)) ||
            !isFamilyPhoneValid)))) ||
    hasOtherContactAddress === undefined ||
    (hasOtherContactAddress === true &&
      (otherContactAddress === undefined ||
        otherContactAddress === '' ||
        otherContactCity === undefined ||
        otherContactCity === '' ||
        otherContactCountry === undefined ||
        otherContactCountry === '' ||
        otherPhoneNumber === undefined ||
        (otherPhoneNumber && (otherPhoneNumber.code === null || otherPhoneNumber.phone === null)) ||
        !isOtherPhoneValid))
  ) {
    complete = false;
  }

  if (complete && ukFamily === true && stayingWithFamily === true) {
    if (!familyMembers || familyMembers.length === 0) {
      complete = false;
    } else {
      complete =
        complete &&
        !familyMembers.some(details => {
          return (
            details.nationality === '' || details.familyName === '' || details.givenName === '' || details.dob === ''
          );
        });
    }
  }

  return { complete };
}
